import "./assets/Tabs.css";
const t = "_tabsCard_1v1s0_3", s = "_withBorder_1v1s0_11", _ = "_tabList_1v1s0_16", a = "_fullWidth_1v1s0_26", i = "_tab_1v1s0_3", n = "_active_1v1s0_71", e = "_inline_1v1s0_84", d = "_tabPanel_1v1s0_112", o = "_hidden_1v1s0_119", l = {
  tabsCard: t,
  withBorder: s,
  tabList: _,
  fullWidth: a,
  tab: i,
  active: n,
  inline: e,
  tabPanel: d,
  hidden: o
};
export {
  l as s
};
